import { pl } from '../../translations/pl';
import React from 'react';
import { TranslationProvider } from '@stateManagement/TranslationContext';

export default function PLTranslations({ children }: { children: React.ReactNode }): React.ReactElement {
    return <TranslationProvider translation={pl}>{children}</TranslationProvider>;
}
